import {TextField, TextFieldProps} from '@mui/material'
import {Controller, useFormContext} from 'react-hook-form'

export const resolve = (path: string, obj: any) => {
  return path.split('.').reduce(function (prev, curr) {
    return prev ? prev[curr] : ''
  }, obj)
}

interface FormTextFieldProps {
  name: string
  label: string
}

type Props = FormTextFieldProps & TextFieldProps
const FormTextField = (props: Props) => {
  const {
    control,
    formState: {errors},
    getValues
  } = useFormContext()

  const error = resolve(props.name, errors)

  const isRequired = !!getValues()[props.name]?.required

  return (
    <Controller
      name={props.name}
      control={control}
      render={({field}) => (
        <TextField
          {...props}
          {...field}
          label={props.label + (isRequired ? ' *' : '')}
          helperText={error?.message}
          error={!!error}
          fullWidth
          onChange={e => {
            field.onChange(
              props.type === 'number'
                ? parseFloat(e.target.value)
                : e.target.value
            )
          }}
          value={field.value ?? ''}
        />
      )}
    />
  )
}

export default FormTextField
